var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// React
import React from 'react';
// Redux
// Digi react form component
import AutocompleteForm from '../../shared/AutocompleteForm/AutocompleteForm';
import CheckboxForm from '../../shared/CheckboxForm/CheckboxForm';
import InputForm from '../../shared/InputForm';
import MultiSelectForm from '../../shared/MultiSelectForm/MultiSelectForm';
import RadioGroupForm from '../../shared/RadioGroupForm/RadioGroupForm';
import SelectForm from '../../shared/SelectForm';
import TitleBlock from '../TitleBlock/TitleBlock';
// Form component
import FormBuilder from '../../components/FormBuilder';
// Form list
import { Formik } from 'formik';
// Core method
import { buildFormProps, getInitialValues } from '../FormBuilder/form.core';
import { getFormValidationSchema } from '../FormBuilder/form.validity.core';
// Hook
import { useVisibility } from '../../hook/visibility.hook';
/**
 * Formik app
 * @param dataSchema
 * @param uiSchema
 * @param formData
 * @param handleSubmit
 * @param handleChange
 * @param stepper
 */
var FormWrapper = function (_a) {
    var dataSchema = _a.dataSchema, uiSchema = _a.uiSchema, formData = _a.formData, handleSubmit = _a.handleSubmit, handleChange = _a.handleChange, stepper = _a.stepper;
    var initialValues = __assign({}, getInitialValues(dataSchema, formData));
    var validationSchema = getFormValidationSchema(dataSchema, uiSchema);
    var visibleFieldList = useVisibility().visibleFieldList;
    var groupProps = buildFormProps(uiSchema, dataSchema);
    /** List of field dependencies */
    var linkedFieldList = groupProps.childrenProps.reduce(function (previous, current) { return (__assign(__assign({}, previous), current.linkedFieldList)); }, {});
    var formProps = {
        Components: {
            FormAutocomplete: AutocompleteForm,
            FormCheckbox: CheckboxForm,
            FormHeader: TitleBlock,
            FormInput: InputForm,
            FormMultiSelect: MultiSelectForm,
            FormRadioPicture: RadioGroupForm,
            FormSelect: SelectForm,
        },
        dataSchemaJson: dataSchema,
        groupProps: groupProps,
        linkedFieldList: linkedFieldList,
        stepper: stepper,
        uiSchemaJson: uiSchema,
    };
    /**
     * Handle submit
     * @param data
     */
    var onSubmit = function (data) {
        var result = visibleFieldList.map(function (fieldName) {
            var _a;
            return (_a = {}, _a[fieldName] = data[fieldName], _a);
        }).reduce(function (previousValue, currentValue) { return (__assign(__assign({}, previousValue), currentValue)); }, {});
        if (handleSubmit) {
            handleSubmit(result);
        }
    };
    /**
     * Handle update
     * @param key
     * @param value
     */
    var updateValue = function (key, value) {
        if (handleChange) {
            handleChange(key, value);
        }
    };
    var render = function (props) { return React.createElement(FormBuilder, __assign({ updateValue: updateValue }, formProps, { validationSchema: validationSchema, formHandler: props })); };
    return React.createElement(Formik, { validationSchema: validationSchema, validateOnBlur: true, initialValues: initialValues, validateOnChange: true, onSubmit: onSubmit, render: render });
};
export default FormWrapper;
//# sourceMappingURL=index.js.map